<template>
  <lazy-div :load="doInit">
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex xs12>
          <quick-info-query @init="doInit"></quick-info-query>
        </v-flex>
        <v-flex xl6 xs12>
          <insured></insured>
        </v-flex>
        <v-flex xl6 xs12>
          <risk></risk>
        </v-flex>
        <v-flex xs12>
          <claimant></claimant>
        </v-flex>
        <v-flex xs12>
          <comments query></comments>
        </v-flex>
      </v-layout>
    </v-container>
  </lazy-div>
</template>

<script>
import { claimStatus } from '@/const/claims'
import QuickInfoQuery from './QuickInfoQuery'
import Insured from './Insured'
import Risk from './Risk'
import Claimant from './Claimant'
import Comments from '../Comments'

export default {
  computed: {
    commonForm() {
      return this.$store.state.claims.claimDetail.commonForm
    },
    currentStatus() {
      return claimStatus[this.$store.state.claims.claimDetail.commonInfo.statusCode]
    }
  },
  methods: {
    async doInit() {
      try {
        const dispatchObj = {
          clmRefNo: this.id,
          query: true
        }
        await this.$store.dispatch('loadClaim', dispatchObj)
      } catch (err) {
        console.log(err)
        throw err
      }
    }
  },
  props: [
    'id'
  ],
  components: {
    QuickInfoQuery,
    Insured,
    Risk,
    Claimant,
    Comments
  }
}
</script>

<style>

</style>
